import React from "react";
import classNames from "classnames";

import { ThemeProvider, mergeRenderers } from "@myst-theme/providers";
import { DEFAULT_RENDERERS } from "myst-to-react";
import { ANY_RENDERERS } from "@myst-theme/anywidget";
import { ALTERNATIVES_RENDERERS, RendererContext } from "./alternatives.js";
import { Scenario } from "./scenario.js";
import "./App.css";

const RENDERERS = mergeRenderers([
  DEFAULT_RENDERERS,
  ANY_RENDERERS,
  ALTERNATIVES_RENDERERS,
]);

function RendererSelector(props) {
  return (
    <div className={classNames("p-2 z-10  bg-white w-full", props.className)}>
      <select
        value={props.renderer} // ...force the select's value to match the state variable...
        onChange={(e) => props.setRenderer(e.target.value)} // ... and update the state variable on any change!
      >
        <option value="pdf">PDF</option>
        <option value="web">Web</option>
      </select>
    </div>
  );
}

function App() {
  const [renderer, setRenderer] = React.useState("pdf");
  return (
    <ThemeProvider renderers={RENDERERS} theme="light">
      <RendererContext.Provider value={renderer}>
        <RendererSelector
          className="sticky top-0"
          renderer={renderer}
          setRenderer={setRenderer}
        />
        <div className="grid grid-cols-3 gap-4 p-4">
          <Scenario
            title="Simple Paragraph"
            yaml={`
  type: alternatives
  children:

  - type: paragraph
    children:

    - type: text
      value: Hello World
      `}
          />
          <Scenario
            title="Two Images"
            yaml={`

  type: alternatives
  children:

  - type: image
    url: http://pngimg.com/uploads/earth/earth_PNG39.png

  - type: image
    url: https://gifdb.com/images/high/earth-spinning-and-rotating-zxmey0cjachu1buc.gif
      `}
          />
          <Scenario
            title="Two Figures"
            yaml={`

  type: alternatives
  children:

  - type: container
    kind: figure
    children:

      - type: image
        url: http://pngimg.com/uploads/earth/earth_PNG39.png

      - type: paragraph
        children:

          - type: text
            value: A PNG of the earth
  
  - type: container
    kind: figure
    children:

      - type: image
        url: >-
          https://gifdb.com/images/high/earth-spinning-and-rotating-zxmey0cjachu1buc.gif
      - type: paragraph
        children:

          - type: text
            value: An animated GIF of the earth    `}
          />
          <Scenario
            title="HTML and an image"
            yaml={`

  type: alternatives
  children:

  - type: html
    value: |-
      <img src="https://wallpaperaccess.com/full/11104424.jpg" />
      I'm an HTML element, seen on web only

  - type: image
    url: https://wallpaperaccess.com/full/11104424.jpg
`}
          />
          <Scenario
            title="AnyWidget and fallback text"
            yaml={`

  type: alternatives
  children:

  - type: anywidget
    esm: https://github.com/jupyter-book/example-js-plugin/releases/download/v1.0.0/plugin.mjs
    model: {}

  - type: paragraph
    children: 
    - type: text
      value: Widgets are not supported in this renderer.
`}
          />
          <Scenario
            title="AnyWidget and a fallback figure"
            yaml={`

  type: alternatives
  children:

  - type: anywidget
    esm: https://github.com/jupyter-book/example-js-plugin/releases/download/v1.0.0/plugin.mjs
    model: {}

  - type: container
    kind: figure
    children:
    - type: image
      url: https://clipart-library.com/2023/Under_Construction_Warning_Sign_PNG_Clipart-839.png
    - type: caption
      children:
      - type: paragraph
        children:
        - type: text
          value: Widgets aren't supported in this renderer
`}
          />
          <Scenario
            title="SVG and a JPEG"
            yaml={`

  type: alternatives
  children:

  - type: image
    url: https://www.svgrepo.com/show/376907/globe-earth-2.svg

  - type: image
    url: http://pngimg.com/uploads/earth/earth_PNG39.png
`}
          />
        </div>
      </RendererContext.Provider>
    </ThemeProvider>
  );
}

export default App;
